import { render, staticRenderFns } from "./ModifyLogistics.vue?vue&type=template&id=340605b6&scoped=true"
import script from "./ModifyLogistics.vue?vue&type=script&lang=js"
export * from "./ModifyLogistics.vue?vue&type=script&lang=js"
import style0 from "./ModifyLogistics.vue?vue&type=style&index=0&id=340605b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340605b6",
  null
  
)

export default component.exports